import React, { useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useMembership from "@/shared/hooks/useMembership";
import PathPickKreamBidGuideModal from "@/features/pathpick/components/request/PathPickKreamBidGuideModal";
import { PathPickRequestFormat } from "@/features/pathpick/types";

interface Props {
  // 생성이 끝난 요청만 파일을 갖는다 — 실패·처리중 요청은 null로 내려와 버튼이 비활성된다.
  // 일부 생성 완료(PARTIAL_COMPLETED)는 파일이 있어 그대로 활성이다.
  fileUrl: string | null;
  // 요청의 다운로드 양식(PathPickRequestItem.format). "NAVER"면 스마트스토어, 그 외는 KREAM.
  format: PathPickRequestFormat | null;
  // 표 셀에서 칸을 꽉 채워야 할 때만 넘긴다 (기본은 글자 폭).
  width?: string;
}

// 패스픽 요청 파일 다운로드 버튼 — 등록 신청 내역 목록의 다운로드 칼럼과
// 신청 상품 내역 모달이 같은 문구·스타일·동작을 쓰도록 한 곳에 모아 둔다.
function PathPickRequestFileDownloadButton({ fileUrl, format, width }: Props) {
  const { t } = useI18nHelper();
  // 체험·멤버십 만료 시 다운로드는 잠근다(조회는 그대로).
  const { isMembershipExpired } = useMembership();
  const isKream = format !== "NAVER";
  const [isKreamGuideOpen, setIsKreamGuideOpen] = useState(false);

  const handleDownload = () => {
    if (!fileUrl) return;
    window.open(fileUrl, "_blank", "noopener,noreferrer");
    // KREAM은 엑셀에서 입찰가를 직접 입력해야 하므로 안내 모달을 함께 노출
    if (isKream) {
      setIsKreamGuideOpen(true);
    }
  };

  return (
    <>
      <AppButton
        variant={"primary"}
        width={width}
        isDisabled={!fileUrl || isMembershipExpired}
        disabledMessage={
          isMembershipExpired
            ? t("path_pick:membership_lock.disabled_tooltip")
            : undefined
        }
        onClick={handleDownload}
      >
        <Flex gap={"4px"} alignItems={"center"} justifyContent={"center"}>
          <CustomIcon
            src={"download"}
            width={16}
            height={16}
            color={"#FFFFFF"}
          />
          <Text textStyle={"body-sm-bold"}>
            {t(
              isKream
                ? "path_pick:sync_download_history.download_kream"
                : "path_pick:sync_download_history.download_smart_store"
            )}
          </Text>
        </Flex>
      </AppButton>
      <PathPickKreamBidGuideModal
        isOpen={isKreamGuideOpen}
        onClose={() => setIsKreamGuideOpen(false)}
      />
    </>
  );
}

export default PathPickRequestFileDownloadButton;
